export const brandingInitialStore = {
  name: "HubFit",
  brandColor: "#2051f1",
  sidebarColor: "#150943"
}